import { mapState } from 'vuex';
export default {
  name: 'NiotaClassicGwMgmtCharts',
  props: {
    packetsBar: {
      type: Object,
      required: false,
      default: () => ({})
    },
    rssiGraph: {
      type: Object,
      required: false,
      default: () => ({})
    },
    lsnrGraph: {
      type: Object,
      required: false,
      default: () => ({})
    },
    sfGraph: {
      type: Object,
      required: false,
      default: () => ({})
    },
    loadingMetrics: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      // selectedTimeFrame: { value: '24h', interval: 'hour', name: this.$i18n_t('NiotaClassic.Devices.details.last24') },
      // timeFrames: [
      //   { value: '24h', interval: 'hour', name: this.$i18n_t('NiotaClassic.Devices.details.last24') },
      //   { value: '1w', interval: 'day', name: this.$i18n_t('NiotaClassic.Devices.details.lastWeek') },
      //   { value: '1M', interval: 'day', name: this.$i18n_t('NiotaClassic.Devices.details.lastMonth') },
      // ],
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])
  }
};